import { render, staticRenderFns } from "./questionTypeForm.vue?vue&type=template&id=5e227f06&scoped=true&"
import script from "./questionTypeForm.vue?vue&type=script&lang=js&"
export * from "./questionTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./questionTypeForm.vue?vue&type=style&index=0&id=5e227f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e227f06",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QInput,QCheckbox,QSelect});
